export default __webpack_public_path__ + "static/The Home_Image 5_carousel 8@2x-b702ac09b50b95f6d1426dd5c615669e.jpg";